"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactImagesUploading = _interopRequireDefault(require("react-images-uploading"));
var _IconDelete = _interopRequireDefault(require("../../icons/General/IconDelete"));
var _IconImage = _interopRequireDefault(require("../../icons/General/IconImage"));
var _Button = _interopRequireDefault(require("../Button"));
var _Image = _interopRequireDefault(require("../Image"));
var _Text = _interopRequireDefault(require("../Text"));
var _IconWithBackground = _interopRequireDefault(require("./IconWithBackground"));
var _styles = require("./styles");
var _UploadButton = _interopRequireDefault(require("./UploadButton"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const ImagePicker = ({
  value = [],
  onChange,
  multiple = true,
  maxNumber,
  acceptType = ['png', 'jpg', 'jpeg'],
  ...imageUploadingProps
}) => {
  const setMainImage = index => {
    let result = Array.from(value);
    result.unshift(result.splice(index, 1)[0]);
    onChange(result);
  };
  return (0, _jsxRuntime.jsx)("div", {
    children: (0, _jsxRuntime.jsx)(_reactImagesUploading.default, {
      value: value?.map(v => {
        if (v.imageUrl) {
          return {
            ...v,
            dataURL: v.imageUrl
          };
        }
        return v;
      }),
      onChange: onChange,
      acceptType: acceptType,
      multiple: multiple,
      maxNumber: maxNumber,
      ...imageUploadingProps,
      children: ({
        onImageUpload,
        onImageRemove,
        imageList,
        dragProps,
        errors,
        isDragging
      }) => {
        const [firstImage, ...rest] = imageList;
        if (!firstImage) return (0, _jsxRuntime.jsx)("div", {
          css: _styles.styles.grid,
          children: (0, _jsxRuntime.jsx)(_UploadButton.default, {
            onClick: onImageUpload,
            isDragging: isDragging,
            ...dragProps
          })
        });
        return (0, _jsxRuntime.jsxs)("div", {
          children: [(0, _jsxRuntime.jsxs)("div", {
            css: _styles.styles.grid,
            children: [(0, _jsxRuntime.jsxs)("div", {
              children: [(0, _jsxRuntime.jsx)(_Image.default, {
                src: firstImage.dataURL || '',
                alt: "Bilde",
                objectFit: "cover",
                width: "100%",
                height: "100%"
              }), Boolean(rest.length) && (0, _jsxRuntime.jsx)("span", {
                css: _styles.styles.pinButton,
                title: "Dette er hovedbilde",
                children: (0, _jsxRuntime.jsx)(_IconWithBackground.default, {
                  icon: (0, _jsxRuntime.jsx)(_IconImage.default, {}),
                  variant: "isMainImage"
                })
              }), (0, _jsxRuntime.jsx)(_Button.default, {
                nostyle: true,
                focusable: true,
                css: _styles.styles.deleteButton,
                onClick: () => onImageRemove(0),
                "aria-label": "Fjern bilde",
                children: (0, _jsxRuntime.jsx)(_IconWithBackground.default, {
                  variant: "delete",
                  icon: (0, _jsxRuntime.jsx)(_IconDelete.default, {})
                })
              })]
            }), Boolean(rest.length) && rest.map((image, index) => (0, _jsxRuntime.jsxs)("div", {
              children: [(0, _jsxRuntime.jsx)(_Image.default, {
                src: image.dataURL || '',
                alt: "Bilde",
                objectFit: "cover",
                height: "100%",
                width: "100%"
              }), (0, _jsxRuntime.jsx)(_Button.default, {
                title: "Sett som hovedbilde",
                nostyle: true,
                focusable: true,
                css: _styles.styles.pinButton,
                "aria-label": "Sett som hovedbilde",
                onClick: () => setMainImage(index + 1),
                children: (0, _jsxRuntime.jsx)(_IconWithBackground.default, {
                  icon: (0, _jsxRuntime.jsx)(_IconImage.default, {}),
                  variant: "setMainImage"
                })
              }), (0, _jsxRuntime.jsx)(_Button.default, {
                nostyle: true,
                focusable: true,
                css: _styles.styles.deleteButton,
                "aria-label": "Fjern bilde",
                onClick: () => onImageRemove(index + 1),
                children: (0, _jsxRuntime.jsx)(_IconWithBackground.default, {
                  variant: "delete",
                  icon: (0, _jsxRuntime.jsx)(_IconDelete.default, {})
                })
              })]
            }, index)), multiple && (0, _jsxRuntime.jsx)(_UploadButton.default, {
              onClick: onImageUpload,
              addMore: true,
              isDragging: isDragging,
              ...dragProps
            })]
          }), errors?.acceptType && (0, _jsxRuntime.jsx)(_Text.default, {
            role: "alert",
            children: "Bilde formatet st\xF8ttes ikke"
          })]
        });
      }
    })
  });
};
var _default = exports.default = ImagePicker;